<template>
	<div class="">
		<div style="margin-bottom: 10px;">
			<van-cell is-link @click="showPopup">{{sendTm}}</van-cell>
		</div>
		<template v-if="dataSource.length==0">
			<div class="ta-c qx">
				<img class="img" src="https://image.soole.com.cn/202101291353.png" alt="">
				<div class="tc-9">暂无记录</div>
			</div>
		</template>
		<template v-else>
			<div class="sign-info f-ac f-jsb bg-f " v-for="(item,index) in dataSource" :key="index">
				<div class="">
					<div class="tit">完成签到获得贡献值</div>
					<div class="tm">{{item.sendTm}}</div>
				</div>
				<div class="num">+{{item.points}}</div>
			</div>
		</template>
		
		
		<van-popup v-model="show" position="bottom" :style="{ height: '50%' }" >
			<van-datetime-picker
			  v-model="currentDate"
			  type="year-month"
			  title="选择年月"
			  :min-date="minDate"
			  :max-date="maxDate"
			  @confirm="confirm"
			  @cancel="cancel"
			/>
		</van-popup>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				sendTm:'',
				userId:'',
				dataSource:[],
				show: false,
				minDate: new Date(2020, 0, 1),
				maxDate: new Date(2030, 10, 1),
				currentDate: new Date(),
			}
		},
		mounted() {
			 document.querySelector('title').innerText = '签到明细';
		},
		created() {
			let query = this.$route.query;
			if(!query.userId){this.$toast("非法访问")}
			this.sendTm = query.sendTm;
			this.userId = query.userId;
			this.currentDate = new Date(query.sendTm);
			this.getList(this.sendTm);
		},
		methods:{
			// 获取签到记录
			async getList(sendTm){
				// 自定义加载图标
				this.$toast.loading({ message: '加载中...',forbidClick: true,loadingType: 'spinner'});
				let params = {
					userId:this.userId,
					sendTm
				}
				let res = await this.$axios.post('common/v1/ContribDetail/list',params);
				if(res.data.success){
					this.$toast.clear();
					res.data.data.forEach((item,index)=>{
						item.sendTm = this.$util.dateFormat(new Date(item.sendTm),"yyyy-MM-dd"); 
					})
					console.log(res.data.data);
					this.dataSource = res.data.data;
					this.show = false;
				}else{
					this.$toast.clear();
				}
			},
			showPopup(){
				this.show = true;
			},
			confirm(value) {
				this.sendTm=this.$util.dateFormat(value,"yyyy-MM");
				this.getList(this.sendTm);
			},
			cancel(value) {
				this.show = false;
			},
		}
	}
</script>

<style lang="less">
	page,body{
		background-color: #F8F8F8 ;
	}
	.sign-info{
		padding: 10px;
		font-size: 14px;
		border-bottom:1px solid #F8F8F8 ;
	}
	.tit{
		font-weight: 700;
	}
	.tm{
		color: #999;
	}
	.num{
		color: #eb3223;
		margin-top: 5px;
		font-weight: 700;
		font-size: 16px;
	}
	.img{
		width: 30%;
		// margin: auto;
	}
	.qx{
		margin: 0 auto; /*水平居中*/
		position: relative;
		top: 50%; /*偏移*/
		margin-top: 25%; 
	}
</style>



// WEBPACK FOOTER //
// src/page/integral/sign-info.vue